/* 
********************************************************
Damage Map (myMap) functions
********************************************************
*/

//@ts-nocheck
// Toggle preceding from @ts-nocheck to @ts-check to enable TypeScript checking

import { consoleMsg } from "./utility.js";
import { damageMarkerIcons, car1000 } from "./images.js";
import { mkAbs } from "./page-init.js";

export { restoreDamageMarkers, mapClicked, resetDialogState, generateDamageImage, storeDamageMarkers, storeInteriorDamageMarkers, captureLogo };

// Make sure our app references are using the global app object associated with window
const app = window.app;

// Function to update image URLs to work with Trevor's directory structure
function updateImagePath(u) {
	// leave absolute/special URLs alone
	if (/^(https?:|data:|blob:|#)/i.test(u)) return u;
	// prefix relative or root-absolute with your bucket base
	return `${app.settings.base}${u.startsWith("/") ? "" : "/"}${u}`;
}

async function loadImgAbs(url) {
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.onload = () => resolve(img);
		img.onerror = (e) => {
			console.error("[IMG ERROR]", { url: mkAbs(url) }, e);
			reject(e);
		};
		img.src = mkAbs(url); // ✅ normalize here, once
	});
}

// Define module namespace variables for storing marker coordinates
let x, y, rect;

// Retrieve any added damage markers from local storage
async function restoreDamageMarkers(elementId = "myMap", type /* "exterior" | "interior" */) {
	consoleMsg("Restoring damage markers...");

	let markers = {};
	const storageKey = app.state.storageKey;

	// Retrieve markers for exterior inspection page
	if (elementId === "myMap") {
		markers = (await store.get(`${storageKey}_damage-markers`)) || {};
		app.state.damageMarkers = markers;
		// Retrieve markers for interior inspection page
	} else if (elementId === "myMap11") {
		markers = (await store.get(`${storageKey}_interior-damage-markers`)) || {};
		app.state.interiorDamageMarkers = markers;
	}

	// Exit early if no markers in this collection
	if (Object.keys(markers).length === 0) return;

	for (const key of Object.keys(markers)) {
		const m = markers[key];
		if (type && m.type !== type) continue; // optional type filter

		consoleMsg("[BUILD SRC - BEFORE NORMALIZE]", {
			raw: m.src,
			startsWithSlash: m.src?.startsWith("/"),
			includesBase: m.src?.includes(app.settings?.base),
		});

		consoleMsg("[RESTORE SRC - BEFORE NORMALIZE]", {
			raw: m.src,
			includesBase: m.src?.includes(app.settings?.base),
		});

		addMarker(m.width, m.height, m.insertionTop, m.insertionLeft, m.src, m.alt, m.x, m.y, elementId);
	}
}

// Function to capture the click event on the #myMap parent div. Coordinates and bounding width captured and passed to alert
function mapClicked(event) {
	consoleMsg("Event = ", event);
	event.stopPropagation();

	// Get bounding rectangle dimensions of parent div: pass to module namespace rect variable
	rect = event.target.getBoundingClientRect();
	consoleMsg("mapClicked R Width: " + rect.width + " R Height: " + rect.height);
	// Calculate x and y coordinate values as offset from top / left of parent viewport
	x = event.clientX - rect.left;
	y = event.clientY - rect.top;
	if (!rect) {
		console.error("Rect is undefined in map click handler");
		return;
	}
	if (event.target.id === "myImg") {
		showDamageDialog("alert1", x, y);
		consoleMsg("myMap coordinates: ", x, y);
	} else {
		consoleMsg(event.target);
	}
}

// showDamageDialog alert
function showDamageDialog(id, x, y) {
	const dialog = document.getElementById(id);
	consoleMsg("showDamageDialog function: " + x + " " + y);
	if (dialog) {
		dialog.present();
	}
	// Remove any existing event listener before adding a new one
	document.removeEventListener("click", okEventHandler);

	// Add the click event listener using document and event delegation
	document.addEventListener("click", okEventHandler);
}

// Define the event handler as a named function
const okEventHandler = function (event) {
	const target = event.target;

	// Ensure that the clicked button is the correct one using event.target
	if (target && target.id === "damage-ok") {
		consoleMsg("Button clicked with target: ", target);
		okEventListener(x, y, rect);

		// Reset alert dialog state
		resetDialogState();
	}
};

// Damage marker alert OK button event listener
async function okEventListener(x, y, rect) {
	var selectVal = app.content.alert1Data;
	var iSrc, iAlt;
	consoleMsg("okEventListener triggered...");
	printCoordinates(x, y);
	consoleMsg("Damage type: ", selectVal);
	if (!app.content.alert1Data) {
		consoleMsg("No damage selected.");
		return;
	}
	// Handling for different damage types
	switch (selectVal) {
		case "scrape":
			iSrc = mkAbs(damageMarkerIcons.exclamationTriangle);
			iAlt = "Scrape damage icon";
			break;
		case "scratch":
			iSrc = mkAbs(damageMarkerIcons.timesCircle);
			iAlt = "Scratch damage icon";
			break;
		case "dent":
			iSrc = mkAbs(damageMarkerIcons.crosshairs);
			iAlt = "Dent damage icon";
			break;
		case "broken":
			iSrc = mkAbs(damageMarkerIcons.exclamationCircle);
			iAlt = "Broken damage icon";
			break;
		case "missing":
			iSrc = mkAbs(damageMarkerIcons.questionCircle);
			iAlt = "Missing damage icon";
			break;
		case "stained":
			iSrc = mkAbs(damageMarkerIcons.stainedCircle);
			iAlt = "Stained damage icon";
			break;
	}
	if (!rect) {
		console.error("rect is undefined in myOk event listener");
	}

	// Variable to create Image object from iSrc (to determine src width / height)
	const img = new Image();
	img.src = iSrc;

	img.onload = function () {
		// Calculate icon offset as percentage of viewport width
		let offset = (rect.width * 0.032) / 2;

		consoleMsg("Offset = ", offset);

		// Set image insertion coordinates, including offset for calculated image size
		let top = ((y - offset) / rect.height) * 100;
		let left = ((x - offset) / rect.width) * 100;

		// Capture each marker in a 'damageMarkers' object
		let markerIndex = "marker";

		markerIndex += Object.keys(app.state.damageMarkers).length;
		consoleMsg("Next marker name = ", markerIndex);
		consoleMsg("iSrc w: " + img.width + " iSrc h: " + img.height);

		// Store relevant data in global damageMarkers object
		app.state.damageMarkers[markerIndex] = {};
		app.state.damageMarkers[markerIndex].width = img.width;
		app.state.damageMarkers[markerIndex].height = img.height;
		app.state.damageMarkers[markerIndex].insertionTop = top;
		app.state.damageMarkers[markerIndex].insertionLeft = left;
		app.state.damageMarkers[markerIndex].src = iSrc;
		app.state.damageMarkers[markerIndex].alt = iAlt;
		app.state.damageMarkers[markerIndex].x = x;
		app.state.damageMarkers[markerIndex].y = y;

		consoleMsg("[BUILD SRC - BEFORE NORMALIZE]", {
			raw: iSrc, // whatever variable holds the icon path
			startsWithSlash: iSrc?.startsWith("/"),
			includesBase: iSrc?.includes(app.settings?.base),
		});

		// Call function to place actual marker on image map
		addMarker(img.width, img.height, top, left, mkAbs(iSrc), iAlt, x, y);
	};
}

// Main function for placing damage markers on image map
async function addMarker(w, h, top, left, iSrc, iAlt, x, y, markerElement = "myMap") {
	consoleMsg("addMarker function called...");

	var i = new Image();
	const markerContainer = document.getElementById(markerElement);

	if (!markerContainer) {
		console.error("Marker container not found: ", markerElement);
		return;
	}

	// Round down width and height values to two decimal places
	w = parseFloat(w).toFixed(2);
	h = parseFloat(h).toFixed(2);
	i.src = mkAbs(iSrc);
	i.alt = iAlt;
	// Set style position property to 'absolute' for precise control over marker placement
	i.style.position = "absolute";

	await new Promise((resolve) => {
		i.onload = function () {
			i.style.top = top + "%";
			i.style.left = left + "%";

			// Add class for specifying image width as a percentage of parent container
			i.classList.add("map-icon");
			resolve();
		};
	});

	// Append the image to the DOM
	markerContainer.appendChild(i);
}

// Function to reset the dialog state
function resetDialogState() {
	// Reset any variables holding coordinate data
	x = null;
	y = null;
	rect = null;

	// Ensure any event listeners related to the dialog are removed
	document.removeEventListener("click", okEventHandler);
	consoleMsg("Dialog state has been reset");
}

async function printCoordinates(x, y) {
	consoleMsg("okEventCoordinates: " + x, y);
}

function normalizeAssetSrc(src) {
	const base = (app.settings.base || "/").replace(/\/+$/, "");
	if (!src) return src;

	// If already absolute (http:, data:, blob:) leave it alone.
	if (/^(https?:|data:|blob:)/i.test(src)) return src;

	// If it already starts with our base, strip the base → make it relative.
	if (base && src.startsWith(base + "/")) return src.slice(base.length + 1);

	// If it’s root-absolute under /assets, drop the leading slash → relative.
	if (src.startsWith("/assets/")) return src.slice(1);

	// If it’s just a filename (e.g. "car-1000.png"), put it under assets/img/.
	if (!src.includes("/")) return `assets/img/${src}`;

	// Otherwise assume it’s already a relative like "assets/img/…"
	return src;
}

// Place markers on damage canvas for capture in generated PDF
async function generateDamageImage(markers, canvasId = "damageCanvas", src = car1000) {
	const storageKey = app.state.storageKey;
	consoleMsg("Generating damage image...");

	const canvas = document.getElementById(canvasId);
	consoleMsg("[GENIMG] canvas lookup", { canvasId, found: !!canvas });

	if (!canvas) {
		console.error("[GENIMG] canvas NOT FOUND", { canvasId });
		return;
	}

	consoleMsg(`DAMAGE CANVAS = ${canvasId}`);

	const imgSrc = normalizeAssetSrc(src); // ← make relative first
	const baseImageSrc = mkAbs(imgSrc);
	consoleMsg("[GENIMG] base image src", { raw: src, mapped: imgSrc, resolved: baseImageSrc });

	let newImage = `${storageKey}_legend-image`; // will be changed below
	const ctx = canvas.getContext("2d");
	consoleMsg("[GENIMG] ctx ready:", !!ctx);

	// Create a new image element for the base damage image
	const baseImage = new Image();

	baseImage.onload = async function () {
		consoleMsg("[GENIMG] base loaded", {
			src: baseImage.src,
			w: baseImage.naturalWidth,
			h: baseImage.naturalHeight,
		});

		// Set canvas size to match the base image
		canvas.width = baseImage.width;
		canvas.height = baseImage.height;
		consoleMsg("[GENIMG] canvas size set", { w: canvas.width, h: canvas.height });

		// Draw the base image onto the canvas
		ctx.drawImage(baseImage, 0, 0);
		consoleMsg("[GENIMG] drew base");

		// Iterate over each marker and draw them on the canvas
		if (canvasId === "damageCanvas") {
			newImage = `${storageKey}_damage-image`;
			const keys = Object.keys(markers || {});
			consoleMsg("[GENIMG] drawing EXTERIOR markers", { count: keys.length });
			keys.forEach(function (markerKey) {
				const marker = markers[markerKey];
				consoleMsg("[GENIMG] draw marker", {
					key: markerKey,
					src: marker?.src,
					resolved: mkAbs(marker?.src),
					x: marker?.x,
					y: marker?.y,
				});
				drawMarkerOnCanvas(ctx, canvas, marker); // (this should set img.src = mkAbs(marker.src))
			});
		} else if (canvasId === "damageCanvas2") {
			newImage = `${storageKey}_interior-damage-image`;
			const keys = Object.keys(markers || {});
			consoleMsg("[GENIMG] drawing INTERIOR markers", { count: keys.length });
			keys.forEach(function (markerKey) {
				const marker = markers[markerKey];
				consoleMsg("[GENIMG] draw marker", {
					key: markerKey,
					src: marker?.src,
					resolved: mkAbs(marker?.src),
					x: marker?.x,
					y: marker?.y,
				});
				drawMarkerOnCanvas(ctx, canvas, marker);
			});
		} else if (canvasId === "logoCanvas") {
			newImage = `${storageKey}_logo-image`;
			consoleMsg("[GENIMG] logo canvas path", { baseImageSrc });
		}

		// Wait for a short period to ensure all images are drawn
		await new Promise((resolve) => setTimeout(resolve, 1000));
		consoleMsg("[GENIMG] wait complete; snapshotting...");

		// Generate PNG data URL
		const dataURL = canvas.toDataURL("image/png");
		consoleMsg("[GENIMG] dataURL length", dataURL?.length, dataURL?.slice(0, 32) + "...");

		try {
			// Save the generated PNG to Ionic storage
			await store.set(newImage, dataURL);
			consoleMsg("[GENIMG] stored", { key: newImage, ok: true });
		} catch (e) {
			console.error("[GENIMG] store failed", { key: newImage, err: e });
		}

		consoleMsg(newImage + " image generated and saved to storage");
	};

	baseImage.onerror = (e) => {
		console.error("[GENIMG] base load FAILED", { baseImageSrc }, e);
	};

	baseImage.src = baseImageSrc;
}

async function captureLogo(logoSrc) {
	const storageKey = app.state.storageKey;
	const url = mkAbs(normalizeAssetSrc(logoSrc));
	const response = await fetch(url);
	const blob = await response.blob();
	const dataURL = await new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onloadend = () => resolve(reader.result);
		reader.onerror = reject;
		reader.readAsDataURL(blob);
	});
	await store.set(`${storageKey}_logo-image`, dataURL);
	consoleMsg("Logo captured and stored directly (no canvas).");
}

// Persist exterior inspection markers in Ionic storage
async function storeDamageMarkers(markers) {
	const storageKey = app.state.storageKey;
	await store.set(`${storageKey}_damage-markers`, markers); // always set
}

// Persist interior inspection markers in Ionic storage
async function storeInteriorDamageMarkers(markers) {
	const storageKey = app.state.storageKey;
	await store.set(`${storageKey}_interior-damage-markers`, markers); // always set
}

// Function to draw a marker directly on the canvas
function drawMarkerOnCanvas(ctx, canvas, marker) {
	consoleMsg("Drawing marker on canvas: ", marker);
	const canvasWidth = canvas.width;
	const canvasHeight = canvas.height;
	consoleMsg("Marker canvas dimensions: ", canvasWidth, canvasHeight);
	const img = new Image();
	img.src = mkAbs(marker.src);
	img.alt = marker.alt;

	img.onload = function () {
		marker.width = 32;
		marker.height = 32;

		/* Canvas drawImage function requires x / y coordinates for image insertion.  Because x / y coordinates can vary 
		based on viewport scale, need to calculate new x / y coordinates based on dimensions of the canvas.  This 
		requires converting the insertion percentages from addMarkers.  This is done in the two constants below.*/
		const left = (marker.insertionLeft / 100) * canvasWidth;
		const top = (marker.insertionTop / 100) * canvasHeight;

		consoleMsg("x: ", marker.x, " y: ", marker.y, "left: ", left, "top: ", top);

		const imgClass = document.createElement("div");
		imgClass.appendChild(img);

		// Draw the marker on the canvas
		ctx.drawImage(img, left, top, marker.width, marker.height);
	};
}

function downloadImage(dataURL, filename) {
	const link = document.createElement("a");
	link.href = dataURL;
	link.download = filename;
	link.click();
}
